import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Martinique: Country = {
    identifier: "Martinique",
    name: "Martinique",
    countryCode: "MQ",
    group: CountryGroup.CENTRAL_AMERICA,
    isUNMember: false,
    flag: "🇲🇶",
    svgPath: "m 304.18675,422.0714 -0.029,0.165 -0.071,0.032 -0.105,-0.137 -0.461,0.019 -0.071,-0.122 -0.004,-0.058 0.222,-0.208 -0.261,-0.056 -0.103,-0.09 -0.221,-0.438 0.018,-0.128 0.092,-0.067 0.149,-0.009 0.282,0.141 0.209,0.202 0.071,0.003 0.024,0.057 -0.042,0.142 0.125,0.12 0.054,0.089 z",
}
